import React from "react";
import { useTranslation } from "react-i18next";
import { formatDate, formatTime, useTimeFormat } from "helpers/timeFormat";

import { useAppSelector, useAppDispatch } from "store/index";
import { handleActivitiesPaginate } from "store/players/list/slice";
import { playersListLimits } from "configs/limits";

import Pagination from "components/Pagination";
import ModalTabSkeleton from "components/global/Skeleton/ModalTabSkeleton/ModalTabSkeleton";
import styles from "./ListActivitiesTab.module.scss";

interface Props {
  limit: number;
  onLimitChange: (limit: number) => void;
}

const ListActivitiesTab: React.FC<Props> = ({ limit, onLimitChange }) => {
  const timeFormat = useTimeFormat();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const activitiesList = useAppSelector(
    (store) => store.players.activitiesList,
  );
  const totalItems = useAppSelector(
    (store) => store.players.totalItemsActivities,
  );
  const totalPages = useAppSelector(
    (store) => store.players.totalPagesActivities,
  );
  const activePage = useAppSelector(
    (store) => store.players.activePageActivities,
  );
  const activitiesFetched = useAppSelector(
    (store) => store.players.isActivitiesFetched,
  );

  const handlePrevClick = () => {
    if (activePage > 1) {
      dispatch(handleActivitiesPaginate(activePage - 1));
    }
  };
  const handleNextClick = () => {
    if (activePage !== totalPages) {
      dispatch(handleActivitiesPaginate(activePage + 1));
    }
  };

  return (
    <div className={`${styles.activities} player-content-wrapper`}>
      {!activitiesFetched ? (
        <div className={styles.table}>
          <ModalTabSkeleton />
        </div>
      ) : (
        <>
          <div className={`${styles.table} inner-table-wrapper`}>
            <table>
              <thead>
                <tr>
                  <th>{t("type")}</th>
                  <th>{t("action")}</th>
                  <th>{t("message")}</th>
                  <th>{t("created")}</th>
                  <th>{t("hash")}</th>
                </tr>
              </thead>
              <tbody>
                {activitiesList?.map((el) => (
                  <tr key={el.hash}>
                    <td>{el.type}</td>
                    <td>{el.action}</td>
                    <td className="big-text">{el.message}</td>
                    <td className="date">
                      <span>{formatDate(el.created)}</span>
                      <span>{formatTime(el.created, timeFormat)}</span>
                    </td>
                    <td>{el.hash}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <Pagination
            activePage={activePage}
            limit={limit}
            totalItems={totalItems}
            totalPages={totalPages}
            limitsArray={playersListLimits}
            handleLimitClick={(nextLimit) => {
              onLimitChange(nextLimit);
              dispatch(handleActivitiesPaginate(1));
            }}
            handleNextClick={handleNextClick}
            handlePrevClick={handlePrevClick}
          />
        </>
      )}
    </div>
  );
};

export default ListActivitiesTab;
